import uuid from 'uuid-random';
import {
    SINGLETON_MODE,
    POPUP_IDS as POPUP_IDS_CORE,
    POPUP_TEMPLATE_IDS as POPUP_TEMPLATE_IDS_CORE
} from '@core/js/components/common/PopupManager/constants';

export const POPUP_IDS = { ...POPUP_IDS_CORE, TIMEOUT_PERIOD_POPUP: uuid() };
export const POPUP_TEMPLATE_IDS = {
    ...POPUP_TEMPLATE_IDS_CORE,
    [POPUP_IDS.TIMEOUT_PERIOD_POPUP]: 'rg_timeout_player_logged_off'
};

export { SINGLETON_MODE };

